import React, { ReactNode, useState } from 'react';
import * as RadixTooltip from '@radix-ui/react-tooltip';
import { styled } from '@stitches/react';

type TooltipType = {
  children: ReactNode;
  title: ReactNode;
  variant: 'light' | 'dark';
};

const StyledTooltip = styled(RadixTooltip.Content, {
  boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.1)',
  borderRadius: '8px',
  fontSize: '12px',
  lineHeight: '17px',
  fontFamily: 'Open Sans'
});

const Tooltip = ({ children, title, variant }: TooltipType) => {
  const [open, setOpen] = useState(false);

  return (
    <RadixTooltip.Provider delayDuration={0}>
      <RadixTooltip.Root open={open} onOpenChange={setOpen}>
        <RadixTooltip.Trigger
          asChild
          onClick={(e) => {
            if (!e.currentTarget.closest('a')) {
              e.stopPropagation();
            }
            setOpen((prev) => !prev);
          }}
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
        >
          {children}
        </RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <StyledTooltip
            className={`z-[1000] max-w-[320px] whitespace-nowrap fixed ${
              variant === 'light'
                ? 'bg-neutral-50 text-neutral-800 px-3 py-2'
                : 'bg-neutral-800 text-neutral-50 px-2 py-1'
            }`}
            sideOffset={5}
            side="bottom"
            avoidCollisions={true}
          >
            {title}
          </StyledTooltip>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
};

export default Tooltip;
